module.exports = __webpack_public_path__ + "img/widget-mockup-v2.ae345d16.png";